import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const NewWindow14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_157)'>
      <path
        d='M2 0.75C1.30964 0.75 0.75 1.30964 0.75 2V9H2.25V2.25H11.75V11.75H6V13.25H12C12.6904 13.25 13.25 12.6904 13.25 12V2C13.25 1.30964 12.6904 0.75 12 0.75H2Z'
        fill='currentColor'
      />
      <path
        d='M4.00001 6.75L6.1894 6.74999L0.969727 11.9697L2.03039 13.0303L7.25 7.81071L7.25 10L8.75 10L8.75 5.24997L4 5.25L4.00001 6.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_157'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

NewWindow14.displayName = 'NewWindow14';
export default NewWindow14;
